export default __webpack_public_path__ + "static/media/icon-close.061fc39a.svg";